import { Globe, path } from "@hscmap/stellar-globe"
import axios from 'axios'
import { V3, V4 } from '@/utils/math'

type SingleBandArea = [number, number, number][][]
type MutliBandArea = { [filter: string]: SingleBandArea }
export type Filter = { filterName: string, color: V3 }

export class AreaRenderer extends path.Renderer {
  constructor(readonly globe: Globe, public url: string, filters: Filter[]) {
    super(globe.gl)
    this.load().then(() => {
      this.setFilter(filters)
    })
  }

  private region: MutliBandArea = {}
  private filters: Filter[] = []

  private async load() {
    const fail = { data: { '$any': [] } as MutliBandArea }
    const { url } = this
    this.region = multibandArea((await axios.get<MutliBandArea>(url).catch((e) => fail)).data)
  }

  private rebuild() {
    const width = 0.01
    const paths: path.Path[] = []

    for (const filter of this.filters) {
      const a = this.region[filter.filterName] || []
      const color: V4 = [...filter.color, 0.75]
      for (const piece of a) {
        const p = new path.Path(piece.map((v) => new path.Point(v as any, color, width)), true, path.JOINT.MITER)
        paths.push(p)
      }
    }

    (() => {
      const a = this.region['$any'] || []
      const color: V4 = Object.keys(this.region).length == 1 ? [0, 1, 0, 0.5] : [1, 1, 1, 0.25]
      for (const piece of a) {
        const p = new path.Path(piece.map((v) => new path.Point(v as any, color, width)), true, path.JOINT.MITER)
        paths.push(p)
      }
    })()

    this.setPaths(paths)
    this.globe.requestRefresh()
  }

  setFilter(filters: Filter[]) {
    this.filters = filters
    this.rebuild()
  }
}

function multibandArea(raw: MutliBandArea | SingleBandArea): MutliBandArea {
  if (Array.isArray(raw)) {
    return { '$any': raw }
  }
  return raw
}
